module.exports = __webpack_public_path__ + "static/media/is.ce053e60.svg";